module.exports = __webpack_public_path__ + "static/n12-logo-c176d2ef47f1d8c54b911bb46023b3e9.svg";